import script from "./EscrowSelectBankModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EscrowSelectBankModal.vue?vue&type=script&lang=ts&setup=true"

import "./EscrowSelectBankModal.vue?vue&type=style&index=0&id=09bd9871&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09bd9871"]])

export default __exports__